import { IMAGE_BUCKET_URL } from "../../DataStore/ApiConstant";

const MainMenu = function ({ object, unKey }) {
  return (
    <li
      key={unKey}
      class="nav-item col-6 col-lg-3 col-md-3 col-sm-3 px-2"
      role="presentation"
    >
      <button
        class={`nav-linkc ${unKey == 0 ? `active` : ``}`}
        id={`${object.pill}-tab`}
        data-bs-toggle="tab"
        data-bs-target={`#${object.pill}`}
        type="button"
        role="tab"
        aria-controls={`${object.pill}`}
        aria-selected="true"
      >
        {object.name}
      </button>
    </li>
  );
};

export default MainMenu;
